import { render, staticRenderFns } from "./SellCoinsCampaignListItem.vue?vue&type=template&id=5e10545e&scoped=true&"
import script from "./SellCoinsCampaignListItem.vue?vue&type=script&lang=ts&"
export * from "./SellCoinsCampaignListItem.vue?vue&type=script&lang=ts&"
import style0 from "./SellCoinsCampaignListItem.vue?vue&type=style&index=0&id=5e10545e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e10545e",
  null
  
)

export default component.exports